import { assignParent } from './common';
function acceptPredicate(visitor) {
  return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function enterNode(listener) {
  listener.enterPredicate && listener.enterPredicate(this);
}
function exitNode(listener) {
  listener.exitPredicate && listener.exitPredicate(this);
}
function getChildren() {
  var children = [this.operator];
  if (this.operand) {
    children.push(this.operand);
  }
  return children;
}
export var predicate = function predicate(operator, operand) {
  return predicateInternal(operator, operand);
};
export var predicateInternal = function predicateInternal(operator, operand) {
  var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var node = {
    operator: operator,
    operand: operand,
    position: position,
    accept: acceptPredicate,
    enterNode: enterNode,
    exitNode: exitNode,
    getChildren: getChildren,
    parent: null
  };
  assignParent(node);
  return node;
};